class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

// Patch renderContents on the prototype so is-empty is always removed after render
const _originalRenderContents = CartDrawer.prototype.renderContents;
CartDrawer.prototype.renderContents = function(parsedState) {
  _originalRenderContents.call(this, parsedState);
  setTimeout(() => {
    this.classList.remove('is-empty');
  }, 50);
};


class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
(function () {
  const DRAWER_ID = '#CartDrawer';
  const BAR_CLASS = 'free-shipping-bar';

  function getThreshold() {
    const bar = document.querySelector(`.${BAR_CLASS}`);
    if (bar) return parseInt(bar.dataset.threshold);
    return window.ssgShippingThreshold || 10000;
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      const moneyFormat = window.money_format || window.Shopify.money_format || '${{amount}}';
      return window.Shopify.formatMoney(cents, moneyFormat);
    }
    return '$' + Math.round(cents / 100).toLocaleString('en-US');
  }

 function buildBarHTML(threshold) {
  return `<div class="free-shipping-bar" data-threshold="${threshold}"><div class="shipping-bar-content" style="margin-bottom: 0;"><p style="font-weight: bold; color: rgb(217, 25, 25); margin: 0; font-size: 14px;">Calculating shipping qualification...</p></div><div class="shipping-bar-track"><div class="shipping-bar-progress" role="progressbar" aria-valuemin="0" aria-valuemax="100"></div></div>`;
}


function updateAllBars(cart) {
  window.updateAllBars = updateAllBars;
  const threshold = getThreshold();
  const total = cart.total_price || 0;

  // Hide bar if cart is empty
  if (total === 0) {
    document.querySelectorAll(`.${BAR_CLASS}`).forEach(bar => bar.style.display = 'none');
    return;
  }

  const remaining = threshold - total;
  const pct = Math.min(100, Math.round((total / threshold) * 100));
  const qualified = remaining <= 0;

  document.querySelectorAll(`.${BAR_CLASS}`).forEach(bar => {
    bar.style.display = ''; // restore if previously hidden
    const contentDiv = bar.querySelector('.shipping-bar-content');
    const progressBar = bar.querySelector('.shipping-bar-progress');

    if (progressBar) {
      progressBar.style.width = pct + '%';
      progressBar.style.backgroundColor = qualified ? '#2f608a' : 'rgb(217, 25, 25)';
      progressBar.setAttribute('aria-valuenow', String(pct));
    }

    if (contentDiv) {
      if (qualified) {
        contentDiv.innerHTML = `<p style="font-weight: bold; color: #2f608a; margin: 0; font-size: 14px;"> <span style="color: #000000;">You've qualified for <span style="color: #2f608a;"> FREE  <span style="color: #000000;">Ground Shipping! </span> <span style="font-weight: normal;"><br> (Available in Canada & USA (Lower 48 states)</span></p>`;
      } else {
        contentDiv.innerHTML = `<p style="font-weight: bold; color: #2f608a; margin: 0; font-size: 14px;"><span style="color: rgb(217, 25, 25);">Spend</span> <span style="color: rgb(217, 25, 25);">${formatMoney(remaining)}</span> more to qualify for <br><span style="color: rgb(217, 25, 25);">FREE Ground Shipping!</span><br><span style="font-weight: normal; font-size: 12px;"> in Canada & USA (Lower 48 States)</span></p>`;
      }
    }
  });
}



  function injectBarIntoDrawer() {
    const drawer = document.querySelector(DRAWER_ID);
    if (!drawer) return;
    if (drawer.querySelector(`.${BAR_CLASS}`)) return;

    const wrapper = document.createElement('div');
    wrapper.innerHTML = buildBarHTML(getThreshold());

    const drawerItems = drawer.querySelector('cart-drawer-items');
    if (drawerItems) {
      drawerItems.insertAdjacentElement('beforebegin', wrapper.firstElementChild);
    } else {
      const inner = drawer.querySelector('.drawer__inner');
      if (inner) inner.prepend(wrapper.firstElementChild);
      else drawer.prepend(wrapper.firstElementChild);
    }

    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => updateAllBars(cart));
  }

  let debounceTimer;
  function fetchAndUpdate() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => updateAllBars(cart));
    }, 300);
  }

  // Trade theme cart refresh
  document.addEventListener('cart:refresh', function (event) {
    if (event.detail && event.detail.cart) {
      updateAllBars(event.detail.cart);
    } else {
      fetchAndUpdate();
    }
  });

  // cartUpdate events
  document.addEventListener('cart:updated', function (event) {
    const cartTotal = event.detail?.resource?.total_price;
    if (cartTotal !== undefined) {
      updateAllBars({ total_price: cartTotal });
    } else {
      fetchAndUpdate();
    }
  });

  document.addEventListener('theme:cart:updated', function (event) {
    const cartTotal = event.detail?.resource?.total_price;
    if (cartTotal !== undefined) {
      updateAllBars({ total_price: cartTotal });
    } else {
      fetchAndUpdate();
    }
  });

  // Shopify pub/sub
  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event.cartData) {
        updateAllBars(event.cartData);
      } else {
        fetchAndUpdate();
      }
    });
  }

  // Cart page mutations
  const cartElement = document.querySelector('cart-items, .cart-items, #main-cart-items');
  if (cartElement) {
    new MutationObserver(fetchAndUpdate).observe(cartElement, { childList: true, subtree: true });
  }

  // Re-inject if drawer content is replaced
  const drawerEl = document.querySelector(DRAWER_ID);
  if (drawerEl) {
    new MutationObserver(function () {
      if (!drawerEl.querySelector(`.${BAR_CLASS}`)) {
        injectBarIntoDrawer();
        fetchAndUpdate();
      }
    }).observe(drawerEl, { childList: true, subtree: true });
  }

  // Watch for drawer appearing in DOM (debounced, cart pages only)
  if (document.querySelector(DRAWER_ID) || document.querySelector('cart-items, .cart-items, #main-cart-items')) {
    let bodyObserverTimer;
    new MutationObserver(function () {
      clearTimeout(bodyObserverTimer);
      bodyObserverTimer = setTimeout(function() {
        injectBarIntoDrawer();
      }, 200);
    }).observe(document.body, { childList: true, subtree: false });
  }


  // Initial load
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => updateAllBars(cart));

  // Patch renderContents to remove is-empty from cart-drawer after render
  function patchRenderContents() {
    const drawerElPatch = document.querySelector('cart-drawer');
    if (!drawerElPatch || typeof drawerElPatch.renderContents !== 'function') return;
    if (drawerElPatch._renderContentsPatched) return;
    drawerElPatch._renderContentsPatched = true;
    const originalRenderContents = drawerElPatch.renderContents.bind(drawerElPatch);
    drawerElPatch.renderContents = function(parsedState) {
      originalRenderContents(parsedState);
      setTimeout(function() {
        drawerElPatch.classList.remove('is-empty');
      }, 50);
    };
  }

  document.addEventListener('DOMContentLoaded', patchRenderContents);
  setTimeout(patchRenderContents, 1000);

  injectBarIntoDrawer();
})();


